const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// Landbruksdirektoratet token to log in:
export let token = '';
export const setToken = (t) => token = t;

export const getApplicationToken = (ar5) => {
  return ar5 ? '' : '?token=' + getParameterByName('token');
};

// Geonorge token to access WMTS base maps:
let gToken; // will be used for minimaps too;
export const setGeonorgeToken = (t) => gToken = t;
export const getGeonorgeToken = () => gToken;

// Geonorge token to access cached WMTSes:
export const requestGeonorgeToken = () => new Promise((resolve, reject) => {
  resolve(
    fetch('/token/token_json.jsp')
    .then(response => response.json())
    .then(json => json.token)
    .catch(() => console.log('Token fra Geonorge kunne ikke hentes.'))
  );
});

/* Drawn features by user */
// Geonorge ticket to access flybilder:
export let ticket_nib_project = '';
export const requestTicket = () => {
  fetch('/token/ticket_json.jsp?id=wms.nib-prosjekter')
  .then(response => response.json())
  .then(json => ticket_nib_project = json.ticket)
  .catch(() => console.log('Ticket fra Geonorge kunne ikke hentes.'));
};
